import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { DiscountResource } from "@exonn/js-sdk";

export const module: ModuleOptions<DiscountResource> = {
  resource: ResourceEnum.Discount,
  bigIcon: <span className={"icon-20-discounts"} />,
  smallIcon: <span className={"icon-15-discounts"} />,
};
